<template>
  <!-- 提现 -->
      <div  class="Booking">
      <TopNavigation  class="topNavigation"></TopNavigation>
      <div class="typeArea">
          <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ name: 'UserInfo', params: { menuInx: '5' } }">我的钱包</el-breadcrumb-item>
              <el-breadcrumb-item class="bread">余额提现</el-breadcrumb-item>
          </el-breadcrumb>
  
          <div class="cont">
              <div class="tit">
                  余额提现
              </div>
              <div class="tixing">
                  <i class="el-icon-info"></i>
                  用户提现金额需大于等于1元
              </div>
              <!-- <el-input v-model="form.num"  placeholder="请输入"></el-input> -->
              <div class="neir">
                  <div class="tianxie">
                      <div class="kuan">
                          可提现金额：
                      </div>
                      <div>
                          <span>￥{{money}}</span>
                      </div>
                  </div>
                  <div  class="tianxie">
                      <div  class="kuan">
                          <span>*</span>提现方式
                      </div>
                      <el-select v-model="form.withdraw_method" placeholder="请选择">
                          <el-option label="银行卡" value="1"></el-option>
                          <!-- <el-option label="区域二" value="beijing"></el-option> -->
                      </el-select>
                  </div>
                  <div  class="tianxie">
                      <div  class="kuan">
                          <span>*</span>开户行
                      </div>
                      <el-input v-model="form.bank_name"  placeholder="请输入"></el-input>
                  </div>
                  <div  class="tianxie">
                      <div  class="kuan">
                          <span>*</span>银行账号
                      </div>
                      <el-input v-model="form.bank_account"  placeholder="请输入"></el-input>
                  </div>
                  <div  class="tianxie">
                      <div  class="kuan">
                          <span>*</span>提现金额
                      </div>
                      <el-input class="jiine" v-model="form.price"  placeholder="请输入"></el-input>
                      <el-button @click="form.price=money">全部提现</el-button>
                  </div>
                  <div>
                      <el-button class="liji" @click="withdrawal">立即提现</el-button>
                  </div>
              </div>
          </div>
      </div>
      </div>
  </template>
      
  <script>
  import TopNavigation from "../HP/TopNavigationB.vue";
  import { withdrawal,userCenter } from "@/api/api";
  export default {
      components:{
          TopNavigation,
      },
      data() {
          return {
              form:{
                withdraw_method:'',
                bank_name:'',
                bank_account:'',
                price:''
              },
              money:JSON.parse(localStorage.getItem('userInfo')).user_money,
              headers:{
                'token':localStorage.getItem('token')
            },
          }
      },
      methods: {
        async getUserInfo(){
            try {
                const res = await userCenter(this.headers);
                if(res.code==1){
                    let storedObject = localStorage.getItem('userInfo');

                    if(storedObject){
                        let obj = JSON.parse(storedObject);
                        obj.freeze_money = res.data.freeze_money;
                        obj.user_money = res.data.user_money;
                        obj.total_amount = Number(res.data.user_money) + Number(res.data.freeze_money);
                        localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                    }

                    this.money = res.data.user_money;
                }
            } catch (error) {
                console.log(error,'获取用户信息失败');
            }
        },
        async withdrawal(){
            try {
                const res = await withdrawal(this.form,this.headers)
                if(res.code==1){
                    this.$message({
                        message: "申请成功，请耐心等待审核",
                        type: "success",
                    });
                    this.getUserInfo()
                    this.form={
                        withdraw_method:'',
                        bank_name:'',
                        bank_account:'',
                        price:''
                    }
                }else{
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            } catch (error) {
                console.log(error,'失败');
            }
        }
      }
  }
  </script>
      
  <style style lang="scss" scoped>
  .topNavigation{
      height: 100PX;
      display: flex;
      justify-content: space-between;
      padding: 0 80px;
      background: #fff;
  }
  
  .Booking{
      background: #F9F9F9;
  }
  .typeArea{
      width: 1200px;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
  }
  
  
  .el-breadcrumb{
      margin: 20px 0;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      .el-breadcrumb__inner is-link{
          color: pink;
      }
  }
  
  :deep(.el-breadcrumb){
      .el-breadcrumb__inner{
          color: #999999 !important;
      }
      .bread{
          span{
              color: #0073F5 !important;
          }
      }
  }
  
  .cont{
      height: 600px;
      background: #FFFFFF;
      border-radius: 12px 12px 12px 12px;
      padding: 32px;
      box-sizing: border-box;
      margin-bottom: 20px;
      .tit{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          font-style: normal;
          text-transform: none;
      }
  
      .tixing{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #999999;
          font-style: normal;
          text-transform: none;
          margin-top: 8px;
      }
  
      .neir{
          margin-top: 100px;
          margin-left: 387px;
          .tianxie{
              display: flex;
              align-items: center;
  
              margin-bottom: 24px;
  
              font-size: 14px;
              span{
                  color: #FE3300;
              }
  
              .kuan{
                  width: 87px;
              }
  
              :deep(.jiine){
                  width: 212px;
                  input{
                      width: 212px;
                  }
              }
              
          }
          :deep(.el-input){
              width: 320px;
              height: 40px;
              input{
                  width: 320px;
                  height: 40px;
                  background: #F9F9F9;
                  border-radius: 8px 8px 8px 8px;
                  border: 0;
              }
          }
  
          .el-button{
              width: 100px;
              height: 40px;
              background: #0073F5;
              border-radius: 8px 8px 8px 8px;
  
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 14px;
              color: #FFFFFF;
              font-style: normal;
              text-transform: none;
              border: 0;
          }
  
          .liji{
              margin-left: 87px;
          }
      }
  }
  </style>